
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";

const namespace = "MuseumModule";

@Component
export default class ColorScalesHeader extends Vue {

  private isInBook():boolean{
    if(this.$route.name=='ArticleIntroduction'
    || this.$route.name=='ArticleIntervals' 
    || this.$route.name=='ArticleColorSpaces'
    || this.$route.name=='ArticleTheColorScale'
    ){
      return true;
    }
    return false;
  }
}

